import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export default function DeviceFilterPopup({
  statusOptions = [],
  globalOptions = [],
  clientOptions = [],
  statusFilter = [],
  globalFilter = [],
  clientFilter = [],
  onToggleStatus,
  onToggleGlobal,
  onToggleClient,
  onReset,
  onClose,
}) {
  return (
    <div className="sum-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="sum-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="device-filter-title"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sum-modal-header">
          <div id="device-filter-title" className="sum-modal-title">
            Filter Devices
          </div>
          <button className="sum-modal-close" onClick={onClose} aria-label="Close filter">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {/* Content */}
        <div className="sum-modal-body filter-body" style={{ gridTemplateColumns: '1fr 1fr' }}>
          {/* Status */}
          <div className="filter-group">
            <div className="sum-filter-title">Status</div>
            <div className="sum-filter-list">
              {statusOptions.map((s) => (
                <label key={s}>
                  <input
                    type="checkbox"
                    checked={statusFilter.includes(s)}
                    onChange={() => onToggleStatus?.(s)}
                    aria-label={`Filter status ${s}`}
                  />
                  {s}
                </label>
              ))}
            </div>
          </div>

          {/* Global */}
          <div className="filter-group">
            <div className="sum-filter-title">Global</div>
            <div className="sum-filter-list">
              {globalOptions.map((c) => (
                <label key={c}>
                  <input
                    type="checkbox"
                    checked={globalFilter.includes(c)}
                    onChange={() => onToggleGlobal?.(c)}
                    aria-label={`Filter global ${c}`}
                  />
                  {c}
                </label>
              ))}
            </div>
          </div>

          {/* Client (full width row) */}
          <div className="filter-group" style={{ gridColumn: '1 / -1' }}>
            <div className="sum-filter-title">Client</div>
            <div className="sum-filter-list">
              {clientOptions.map((c) => (
                <label key={c}>
                  <input
                    type="checkbox"
                    checked={clientFilter.includes(c)}
                    onChange={() => onToggleClient?.(c)}
                    aria-label={`Filter client ${c}`}
                  />
                  {c}
                </label>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="sum-modal-footer" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button className="action-btn" onClick={onReset}>Reset</button>
        </div>
      </div>
    </div>
  );
}
